import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IoStarOutline, IoStar } from "react-icons/io5";

import * as userActions from "../../../../actions/userActions";

const Favorite = ({
  row = {},
  toggleable = true,
  value: initialValue,
  actions,
  auth
}) => {
  const [isFavorited, setIsFavorited] = useState(false);

  useEffect(() => {
    setIsFavorited(initialValue);
  }, [initialValue]);

  const handleToggleFavorite = async () => {
    if (toggleable) {
      setIsFavorited(!isFavorited);
      await actions.updateFavorites(auth.user, row._original._id);
      // await ProjectService.put(`/favorite/${row._original._id}`);
      // const token = localStorage.getItem("grav_token");
      // actions.checkAuth(token);
    }
  };
  return (
    <div
      className="text-center"
      role="presentation"
      onKeyDown={() => {}}
      onClick={handleToggleFavorite}
    >
      {isFavorited ? (
        <IoStar style={{ color: "#FFD275", textAlign: "center" }} />
      ) : (
        <IoStarOutline style={{ color: "#848487", textAlign: "center" }} />
      )}
    </div>
  );
};

Favorite.propTypes = {
  row: PropTypes.object,
  toggleable: PropTypes.bool,
  value: PropTypes.bool,
  actions: PropTypes.object,
  auth: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    auth: state.reducers.auth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...userActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(Favorite);
